export enum AgentInternalRequestType {
  // Core agent processing types
  PROCESSING = "processing",
  ROUTE = "route",
  ROUTE_COMPLETION_FG = "route_completion_fg",
  ROUTE_COMPLETION_BG = "route_completion_bg",
  
  // Agent strategy management
  BUILD_STRATEGY = "build_strategy",
  REBUILD_STRATEGY = "rebuild_strategy",
  
  // Agent operation types
  ORCHESTRATE = "orchestrate",
  ORCHESTRATION = "orchestration",
  RESPOND = "respond",
  FINAL_RESPONSE = "final_response",
  EXTRACT = "extract",
  POST_ROUTE_STATE_UPDATE = "post_route_state_update",
  
  // Agent execution modes
  DIRECT = "direct",
  REASONING = "reasoning",

}

/**
 * Helper function to check if a request type is internal/admin
 */
export const isInternalRequestType = (actionType?: string, requestType?: string): boolean => {
  if (!actionType && !requestType) return false;
  
  const normalizedRequestType = requestType?.toLowerCase();
  const normalizedActionType = actionType?.toLowerCase();
  
  // Check for admin_internal request type
  if (normalizedRequestType === "admin_internal") {
    return true;
  }
  
  // Check if action type is one of the internal types
  const internalTypes = Object.values(AgentInternalRequestType).map(type => type.toLowerCase());
  return normalizedActionType ? internalTypes.includes(normalizedActionType) : false;
};
